import { Component } from '@angular/core';
import { PimProductComponent } from 'gung-standard';

@Component({
    selector: 'colmec-pim-product',
    templateUrl: './colmec-pim-product.component.html',
    styleUrl: './colmec-pim-product.component.scss',
    standalone: false
})
export class ColmecPimProductComponent extends PimProductComponent {

}
